// import React from 'react'
// import StatCard from '../panelComponents/DashboardComponent/StatCard';
// import { BiDollarCircle } from "react-icons/bi";
// import AllOrder from './AllOrders';
// import SalesChart from '../panelComponents/DashboardComponent/SalesChart';
// import DashboardQuickAddSection from '../panelComponents/DashboardComponent/BestSellerCard';
// const stats = [
//   {
//     title: "Total Sales",
//     value: "7,265",
//     change: "+11.02%",
//     trend: "up",
//     icon: <BiDollarCircle size={20}/>,
//     bg: "bg-[#E3F5FF]",
//     iconBg: "bg-blue-500",
//     textColor: "text-green-500",
//   },
//   {
//     title: "Total Orders",
//     value: "3,671",
//     change: "-0.03%",
//     trend: "down",
//     icon: "🛒",
//     bg: "bg-[#F7F9FB]",
//     iconBg: "bg-gray-200",
//     textColor: "text-red-500",
//   },
//   {
//     title: "Total Visitors",
//     value: "156",
//     change: "+15.03%",
//     trend: "up",
//     icon: "👤",
//     bg: "bg-[#F7F9FB]",
//     iconBg: "bg-gray-200",
//     textColor: "text-green-500",
//   },
//   {
//     title: "Active Users",
//     value: "2,318",
//     change: "+6.08%",
//     trend: "up",
//     icon: "👥",
//     bg: "bg-[#F7F9FB]",
//     iconBg: "bg-gray-200",
//     textColor: "text-green-500",
//   },
//     {
//     title: "New Users",
//     value: "7,265",
//     change: "+11.02%",
//     trend: "up",
//     icon: "💲",
//     bg: "bg-[#E3F5FF]",
//     iconBg: "bg-blue-500",
//     textColor: "text-green-500",
//   },
//   {
//     title: "Low Stock Alerts",
//     value: "3,671",
//     change: "-0.03%",
//     trend: "down",
//     icon: "🛒",
//     bg: "bg-[#F7F9FB]",
//     iconBg: "bg-gray-200",
//     textColor: "text-red-500",
//   },
//   {
//     title: "Returns",
//     value: "156",
//     change: "+15.03%",
//     trend: "up",
//     icon: "👤",
//     bg: "bg-[#F7F9FB]",
//     iconBg: "bg-gray-200",
//     textColor: "text-green-500",
//   },
//   {
//     title: "Active Users",
//     value: "2,318",
//     change: "+6.08%",
//     trend: "up",
//     icon: "👥",
//     bg: "bg-[#F7F9FB]",
//     iconBg: "bg-gray-200",
//     textColor: "text-green-500",
//   },
// ];

// const Dashboard = () => {
//   return (
//     <div className=''>
//       <h1 className="text-2xl font-bold mb-4">Dashboard</h1>
//       <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-6">
//         {stats.map((item, index) => (
//           <StatCard key={index} item={item} />
//         ))}
//     </div>
//     <div className="py-4">
//       <SalesChart />
//     </div>
// <DashboardQuickAddSection />
//     <AllOrder showStats={false} />

//     </div>
//   );
// }

// export default Dashboard

import React, { useEffect, useState, useCallback } from "react";
import StatCard from "../panelComponents/DashboardComponent/StatCard";
import SalesChart from "../panelComponents/DashboardComponent/SalesChart";
import AllOrder from "./AllOrders";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";
import { BiDollarCircle } from "react-icons/bi";
import DashboardQuickAddSection from "../panelComponents/DashboardComponent/DashboardQuickAddSection";
import SelectDropdown from "../customStyles/SelectDropdown";
import CustomDatePicker from "../customStyles/CustomDatePicker";
import { GiShoppingCart } from "react-icons/gi";
import { FaUsers } from "react-icons/fa";
import { ImUsers } from "react-icons/im";
import { TbTruckReturn } from "react-icons/tb";
import { TbTruckDelivery } from "react-icons/tb";
import RevenueAnalyticsSection from "../panelComponents/DashboardComponent/RevenueAnalyticsSection";
const Dashboard = () => {
  const now = new Date();
  const defaultMonth = String(now.getMonth() + 1).padStart(2, "0"); // "01".."12"
  const defaultYear = now.getFullYear();

  const [month, setMonth] = useState(defaultMonth);
  const [year, setYear] = useState(defaultYear);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);

  const monthOptions = [
    { label: "Jan", id: "01" },
    { label: "Feb", id: "02" },
    { label: "Mar", id: "03" },
    { label: "Apr", id: "04" },
    { label: "May", id: "05" },
    { label: "Jun", id: "06" },
    { label: "Jul", id: "07" },
    { label: "Aug", id: "08" },
    { label: "Sep", id: "09" },
    { label: "Oct", id: "10" },
    { label: "Nov", id: "11" },
    { label: "Dec", id: "12" }
  ];

  const yearOptions = Array.from({ length: 5 }, (_, i) => {
    const y = new Date().getFullYear() - i;
    return { label: y.toString(), id: y };
  });

  useEffect(() => {
    if (month && year) {
      const start = `${year}-${month}-01`;

      const end = new Date(year, parseInt(month), 0)
        .toISOString()
        .slice(0, 10);

      setFromDate(start);
      setToDate(end);
    }
  }, [month, year]);

  const fetchDashboardStats = useCallback(async () => {
    try {
      setLoading(true);

      const params = {};

      // 1️⃣ Date range highest priority
      if (fromDate && toDate && !month) {
        params.from = fromDate;
        params.to = toDate;
      }

      // 2️⃣ Month + Year
      if (month) {
        params.month = month;
        params.year = year;
      }

      // 3️⃣ Only Year
      if (!month && year) {
        params.year = year;
      }

      const res = await api({
        ...SummaryApi.dashboardStats,
        params
      });

      if (res.data.success) {
        const s = res.data.stats;

        setStats([
          {
            title: "Total Sales",
            value: s.totalSales.value,
            change: `${s.totalSales.percentage}%`,
            trend: s.totalSales.trend,
            icon: <BiDollarCircle size={20} />,
            bg: "bg-[#E3F5FF]",
            iconBg: "bg-blue-500",
            iconText: "text-white",
            textColor: s.totalSales.trend === "up"
              ? "text-green-500"
              : "text-red-500"
          },
          {
            title: "Total Orders",
            value: s.totalOrders.value,
            change: `${s.totalOrders.percentage}%`,
            trend: s.totalOrders.trend,
            icon: <GiShoppingCart size={20} strokeWidth={2} />,
            bg: "bg-[#F7F9FB]",
            iconBg: "bg-white",
            iconText: "text-black",
            textColor: s.totalOrders.trend === "up"
              ? "text-green-500"
              : "text-red-500"
          },
          {
            title: "Total Users",
            value: s.totalUsers.value,
            change: `${s.totalUsers.percentage}%`,
            trend: s.totalUsers.trend,
            icon: <FaUsers size={20} />,
            bg: "bg-[#F7F9FB]",
            iconBg: "bg-white",
            iconText: "text-black",
            textColor: s.totalUsers.trend === "up"
              ? "text-green-500"
              : "text-red-500"
          },
          {
            title: "New Users",
            value: s.newUsers.value,
            change: `${s.newUsers.percentage}%`,
            trend: s.newUsers.trend,
            icon: <ImUsers size={20} />,
            bg: "bg-[#F7F9FB]",
            iconBg: "bg-white",
            iconText: "text-black",
            textColor: s.newUsers.trend === "up"
              ? "text-green-500"
              : "text-red-500"
          },
          {
            title: "Active Users",
            value: s.activeUsers.value,
            change: `${s.activeUsers.percentage}%`,
            trend: s.activeUsers.trend,
            icon: <ImUsers size={20} />,
            bg: "bg-[#F7F9FB]",
            iconBg: "bg-white",
            iconText: "text-black",
            textColor: s.activeUsers.trend === "up"
              ? "text-green-500"
              : "text-red-500"
          },
          {
            title: "Low Stock Alerts",
            value: s.lowStockAlerts.value,
            change: "",
            trend: s.lowStockAlerts.trend,
            icon: "⚠️",
            bg: "bg-[#FFF4E5]",
            iconBg: "bg-orange-500",
            textColor: "text-red-500"
          },
          {
            title: "Delivered Orders",
            value: s.deliveredOrders.value,
            change: `${s.deliveredOrders.percentage}%`,
            trend: s.deliveredOrders.trend,
            icon: <TbTruckDelivery size={20} />,
            bg: "bg-[#F7F9FB]",
            iconBg: "bg-white",
            iconText: "text-black",
            textColor: s.deliveredOrders.trend === "up"
              ? "text-green-500"
              : "text-red-500"
          },
          {
            title: "Returns",
            value: s.returns.value,
            change: `${s.returns.percentage}%`,
            trend: s.returns.trend,
            icon: <TbTruckReturn size={20} />,
            bg: "bg-[#F7F9FB]",
            iconBg: "bg-white",
            iconText: "text-black",
            textColor: "text-red-500"
          }
        ]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [fromDate, toDate, month, year]);


  useEffect(() => {
    fetchDashboardStats();
  }, [fetchDashboardStats]);

  useEffect(() => {
    if (month) {
      setFromDate("");
      setToDate("");
    }
  }, [month]);

  const handleFromDateChange = (date) => {
    setMonth("");
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setMonth("");
    setToDate(date);
  };


  return (
    <div>
      {/* HEADER + FILTER */}
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
        <div>
          <h1 className="text-2xl font-bold mb-2">Dashboard</h1>
        </div>
        <div className="flex flex-col md:flex-row gap-3 items-center w-full md:w-auto">
          {/* Month */}
          <SelectDropdown
            options={monthOptions}
            value={month}
            onChange={setMonth}
            placeholder="Month"
          />

          {/* Year */}
          <SelectDropdown
            options={yearOptions}
            value={year}
            onChange={setYear}
            placeholder="Year"
          />

          {/* From Date */}
          <CustomDatePicker
            value={fromDate}
            onChange={handleFromDateChange}
          />

          <CustomDatePicker
            value={toDate}
            onChange={handleToDateChange}
          />
        </div>
      </div>

      {/* STAT CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-6 mb-4">
        {loading
          ? "Loading..."
          : stats.map((item, index) => (
            <StatCard key={index} item={item} />
          ))}
      </div>
      <div className="space-y-4">
      <RevenueAnalyticsSection/>
        <SalesChart />
      <DashboardQuickAddSection />
      <AllOrder showStats={false} />
      </div>

    </div>
  );
};

export default Dashboard;
